import { ValueLabelConnected } from 'features/BillOfMaterials/store/components/ValueLabelConnected'
// import { projectDiscountOrSurchargeSelector } from 'features/BillOfMaterials/store/selectors/projectDiscountOrSurchargeSelector'
import { useTranslation } from 'react-i18next'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'

// export function ProjectDiscountOrSurcharge() {
//   const { t } = useTranslation()
//   return (
//     <ValueLabelConnected
//       propertySelector={projectDiscountOrSurchargeSelector}
//       valueLabelProps={{
//         label: t('project:discount-surcharge'),
//       }}
//     />
//   )
// }

export function ProjectSurchargeRatio() {
  const { t } = useTranslation()

  return (
    <ValueLabelConnected
      propertySelector={projectSelectors.projectSurchargeRatioSelector}
      valueLabelProps={{
        label: t('common:surcharge', 'surcharge'),
        emptyString: '-',
      }}
    />
  )
}

export function ProjectDiscountRatio() {
  const { t } = useTranslation()

  return (
    <ValueLabelConnected
      propertySelector={projectSelectors.projectDiscountSelector}
      valueLabelProps={{
        label: t('common:discount', 'discount'),
        emptyString: '-',
      }}
    />
  )
}
